import "../modules/jquery.exitintent.min";
import Modal from "bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "../modules/header";
import Pagination from "../modules/pagination";
import carousels from "../modules/carousels";
import Steps from "../modules/blocks/steps";
import testimSlider from "../modules/blocks/testimSlider";
import sliderWithImage from "../modules/blocks/sliderWithImage";

// Block Animations
import Lottie from "../modules/blocks/lottie";
import Sticky from "../modules/sticky";
import Navigation from "../modules/navigation";
import jobs from "../modules/blocks/jobs";
import hiwAnimation from "../modules/blocks/how-it-works";
import HeroAnimation from "../modules/blocks/hero";
import PerkAnimation from "../modules/blocks/perks";
import ContactAnimation from "../modules/blocks/contact";
import CultureAnimation from "../modules/blocks/culture";
import HomeHeroAnimation from "../modules/blocks/home-hero";
import ApproachAnimation from "../modules/blocks/approach";
import SolutionsHighlightsAnimation from "../modules/blocks/solutions-highlights";
import ImpactAnimation from "../modules/blocks/impact";
import RelatedResources from "../modules/blocks/related-resources";
import testimonials from "../modules/blocks/testimonials";
import FeaturesAnimation from "../modules/blocks/features";
import SolutionsAnimation from "../modules/blocks/solutions";
import AwardsAnimation from "../modules/blocks/awards";
import WhyThreatAnimation from "../modules/blocks/why-threat";
import HighlyRatedAnimation from "../modules/blocks/highly-rated";
import tabbedAnimation from "../modules/blocks/tab-content";
import subscribeAnimation from "../modules/blocks/subscribe";
import timer from "../modules/blocks/timer";
import FeaturedContentAnimation from "../modules/blocks/featured-content";
import Resources from "../modules/resources";
import Documentation from "../modules/documentation";

export default {
  init() {
    AOS.init();
    Header.init();
    Steps();
    Pagination();
    testimSlider();
    sliderWithImage();
    jobs.init();
    Lottie();
    carousels.init();
    timer.init();
    Sticky.init();
    Navigation.init();
    testimonials.init();
    hiwAnimation.init();
    HeroAnimation.init();
    PerkAnimation.init();
    Documentation.init();
    AwardsAnimation.init();
    tabbedAnimation.init();
    ImpactAnimation.init();
    CultureAnimation.init();
    ContactAnimation.init();
    RelatedResources.init();
    ApproachAnimation.init();
    FeaturesAnimation.init();
    HomeHeroAnimation.init();
    subscribeAnimation.init();
    SolutionsAnimation.init();
    WhyThreatAnimation.init();
    HighlyRatedAnimation.init();
    FeaturedContentAnimation.init();
    SolutionsHighlightsAnimation.init();

    if (
      $("body").hasClass("resources") ||
      $("body").hasClass("page-template-template-sub-resources")
    ) {
      Resources();
    }

    $(".search-head img, .mobile-search").on("click", function (e) {
      e.preventDefault();
      $("#search-overlay").fadeIn();
      $(".search-form input[type=text]").focus();
    });

    $("#search-overlay").click(function (e) {
      // Check if click was triggered on or within #menu_content
      if ($(e.target).closest(".search-form").length > 0) {
      } else {
        $("#search-overlay").fadeOut();
      }
      // Otherwise
      // trigger your click function
    });

    $(".clear-search").on("click", function (e) {
      e.preventDefault();
      $(".search-input").val(" ").focus();
    });

    $(".close-search").on("click", function (e) {
      e.preventDefault();
      $("#search-overlay").fadeOut();
    });

    function getCookie(cname) {
      let name = cname + "=";
      let ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    $(".close-banner").on("click", function (e) {
      e.preventDefault();
      var cookie = $(this).data("cookieID");
      document.cookie = "visited=" + cookie;
      var CookieDate = new Date();
      CookieDate.setFullYear(CookieDate.getFullYear() + 10);
      var cookie = $(this).data("cookieid");
      document.cookie =
        cookie + "=visited; expires=" + CookieDate.toUTCString() + "; path=/;";

      $("#top-banner").hide();

      $(
        ".has-top-banner .navbar, .has-top-banner .global-main, .push-top-banner"
      ).animate({
        marginTop: 0,
      });
    });

    $(".btn-close-modal").on("click", function (e) {
      e.preventDefault();
      var cookie = $(this).data("cookieID");
      document.cookie = "modal_visited=" + cookie;
      $(".conversion-modal").fadeOut();
      var CookieDate = new Date();
      CookieDate.setFullYear(CookieDate.getFullYear() + 10);
      var cookie = $(this).data("cookieid");
      document.cookie =
        cookie +
        "=modal_visited; expires=" +
        CookieDate.toUTCString() +
        "; path=/;";
    });

    var cookie_opt = "";

    $.exitIntent("enable");

    $(document).bind("exitintent", function () {
      var checkCookie = getCookie("modal_visited");
      if (!checkCookie) {
        $(".conversion-modal").fadeIn();
        $(".conversion-modal").css("display", "flex");
      }
    });

    var timeoutTime = cookie_opt.timeout;

    if (timeoutTime) {
      setTimeout(function () {
        var checkCookie = getCookie("modal_visited");
        if (!checkCookie) {
          $(".conversion-modal").fadeIn();
          $(".conversion-modal").css("display", "flex");
        }
      }, timeoutTime);
    }

    $('.video-content iframe').wrap('<div class="video-wrap" />');

    $('.video-wrapper a').on('click', function(e){
      e.preventDefault();
      var target = $(this).data('target');
      $(target).addClass('active');
    });

    $('.video-modal-embed .close a').on('click', function(e){
      e.preventDefault();
      $('.video-modal-embed').removeClass('active');
    })
  },
  finalize() {},
};
